import { render, staticRenderFns } from "./idCardsGridBlock.vue?vue&type=template&id=42cb3a16&scoped=true"
import script from "./idCardsGridBlock.vue?vue&type=script&lang=js"
export * from "./idCardsGridBlock.vue?vue&type=script&lang=js"
import style0 from "./idCardsGridBlock.vue?vue&type=style&index=0&id=42cb3a16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb3a16",
  null
  
)

export default component.exports